import type { SessionRecord } from '../types'
import { SessionDataTree } from './SessionDataTree'

/**
 * The terminal state of a session's extracts, collapsible.
 *
 * This is the `extracts` column — what each extract settled on when the run
 * finished — as opposed to the per-step captures in the structured report,
 * where the same name can appear more than once as later steps overwrite it.
 * Renders nothing when the run captured no extracts, which is the normal case
 * for workflows that only act.
 */
export function SessionExtracts({
  extracts,
}: {
  extracts: SessionRecord['extracts']
}) {
  if (!extracts) return null
  const entries = Object.entries(extracts)
  if (entries.length === 0) return null

  return (
    <details open className="mb-8">
      <summary className="cursor-pointer select-none text-xl font-semibold text-gray-900">
        Extracts{' '}
        <span className="text-sm font-normal text-gray-500">
          ({entries.length})
        </span>
      </summary>
      <div className="mt-3">
        <SessionDataTree entries={entries} />
      </div>
    </details>
  )
}
